<template>
    <commonPopup
        header="服务说明"
        footer="我知道了"
        @footerClick="footerClick">
        <div class="ctn">
            <div v-for="(item, index) in serviceList" :key = "index">
                <p class="title">{{item.title}}</p>
                <p>{{item.desc}}</p>
            </div>
        </div>        
    </commonPopup>
</template>

<script>
import commonPopup from "@/components/common/popup.vue";
export default {
  name: "rule",
  props:{
      serviceList: Array,
  },
  components: {
    commonPopup
  },
  created: function() {},
  methods:{
      footerClick(){
          this.$emit('footerClick');
      },
  }
};
</script>

<style lang="scss" scoped>
    .ctn {
        font-family: PingFangSC-Regular;
        font-size: .28rem;
        line-height: .40rem;
        color: #919294;
        padding: .3rem .53rem;
        div{
            margin-bottom: .2rem;
            p {
                margin-bottom: .1rem;
                color: #919294;
                font-family: PingFangSC-Regular;
                font-size: .28rem;
            }
            .title{
                font-family: PingFangSC-Medium;
	            font-size: .30rem;
                color: #4a4b4c;
            }
        }
    }
</style>